import React from 'react';
import LogoDirecional from '../../assets/LogoDirecionalBranco.png';
import LogoRiva from '../../assets/logos/Grupo 291@2x.png';
import { ReactComponent as Whats } from '../../assets/whatsapp_black_24dp.svg';
import TermosUso from './TermosDeUso';

import './styles.scss';

const Footer = ({ tema }) => {
  return (
    <footer className='footer '>
      <div className='footer__inner centralized-space-between'>
        <div className='footer__inner__logo centralized'>
          {tema.tipo == 'Direcional' && (
            <img src={LogoDirecional} alt='Direcional' />
          )}
          {tema.tipo == 'Riva' && <img src={LogoRiva} alt='Riva' />}
        </div>
        <div className='footer__inner__versao-portal centralized-column'>
          <span>2021 - PORTAL DO CLIENTE</span>
          <TermosUso tema={tema} />
        </div>
        <div className='footer__inner__horario centralized-column'>
          <span>Central de Relacionamento</span>
          <span>De segunda a sexta-feira das 09h às 18h</span>
        </div>
        <div className='footer__inner__fone'>
          {tema.tipo == 'Direcional' && (
            <div className='centralized'>
              <span>31-4002-2600</span>
              <Whats fill='#ffffff' />
            </div>
          )}
          {tema.tipo == 'Riva' && (
            <div className='centralized'>
              <span>31-4007-1620</span>
              <Whats fill='#ffffff' />
            </div>
          )}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
